import { useMemo, useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { liveFilters, liveZones } from "@/mocks/content";

export default function LiveZones() {
  const [active, setActive] = useState("all");

  const zones = useMemo(
    () => (active === "all" ? liveZones : liveZones.filter((z) => z.group === active)),
    [active]
  );

  return (
    <section id="live" className="w-full bg-background-100 py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="直播分区导航"
            title="按类型找直播，而不是无限下滑"
            desc="平台把直播按内容形态分成若干大类。切换下面的标签可以只看某一类分区，每个分区都标注了活跃高峰时段与内容特点。"
          />
          <div className="text-sm text-foreground-500 shrink-0">
            共 <span className="font-heading font-bold text-primary-600 text-lg">{zones.length}</span> 个分区
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {liveFilters.map((f) => (
            <button
              key={f.id}
              type="button"
              onClick={() => setActive(f.id)}
              className={`px-1 py-1 rounded-full text-sm transition-colors cursor-pointer ${
                active === f.id ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-700 border border-background-300 hover:border-primary-300"
              }`}
            >
              <span className="block px-3 py-1.5 whitespace-nowrap">{f.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {zones.map((z) => (
            <article
              key={z.id}
              className="rounded-lg bg-background-50 border border-background-200/80 p-5 md:p-6 hover:border-primary-300 hover:-translate-y-0.5 transition-all"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 text-xl">
                  <i className={z.icon}></i>
                </span>
                <span className="inline-flex items-center gap-1 text-[11px] text-primary-700 bg-primary-50 px-2 py-1 rounded-full whitespace-nowrap">
                  <i className="ri-time-line"></i>
                  {z.heat}
                </span>
              </div>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{z.name}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{z.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {z.bullets.map((b) => (
                  <span key={b} className="text-[11px] text-foreground-600 bg-background-100 border border-background-200 px-2 py-1 rounded-full">
                    {b}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}